<template>
  <v-card class="pa-2">
    <v-flex>
      <v-layout column align-center overflow-hidden>
        <v-avatar :size="pictureSize" color="primary">
          <img v-if="picture"
            class="img"
            :src="picture"
            :alt="name"
          >
          <v-icon v-else x-large dark>account_circle</v-icon>
        </v-avatar>
        <v-layout column align-center overflow-hidden pt-2 class="fill-width">
          <h6 class="headline font-weight-medium text-xs-center text-truncate fill-width" v-text="name"/>
          <h6 class="subheading font-weight-regular text-xs-center text-truncate fill-width" v-text="document"/>
        </v-layout>
      </v-layout>
    </v-flex>
  </v-card>
</template>

<script>
export default {
  name: 'ResponsibleInfos',

  props: {
    document: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    picture: {
      type: String,
      default: ''
    },
    pictureSize: {
      type: Number,
      default: 150
    }
  }
}
</script>

<style lang="stylus" scoped>
  .img
    overflow hidden
  .fill-width
    width 100%
</style>
